import { triggerLoginModal } from "../../components/modals/LoginRegisterModal";
import { CONSTANTS } from "../../core/constants";
import { removeAchievementsFromLS } from "../gamification/events";
import { doRequest } from "../http";
import { cleanLocalProjects } from "../localstorage/clean";
import { addLogin } from "../stats";
import { sanitizeInput, sanitizePassword } from "../validateinput";
import { clearCloudSession, getCloudServerPath, getCloudUser, setCloudUser } from "./cloud";


export function cleanedUserName() {
  return getCloudUser().userName?.split('@')[0];
}

export const userHasRoleFromList = (roles : string[]) => {
  let hasRole = false;
  roles.forEach(role => {
    hasRole = hasRole || userHasRole(role);
  });
  //console.log('userHasRoleFromList?', roles, hasRole)
  return hasRole;
}

export const userHasRole = (role : string) : boolean => {
  if (!getCloudUser().userCaps) return false;
  if (getCloudUser().userCaps) {
    const caps : any = getCloudUser().userCaps;
    const userRole = caps.hasOwnProperty(role);
    return (userRole !== undefined && userRole !== false);
  }
  return false;
}

export const loginUser = async (user : string, pw : string) => {
  const form = new FormData();
  const sanitizedUser = sanitizeInput(user, CONSTANTS.USER_NAME_MIN, CONSTANTS.USER_NAME_MAX);
  const sanitizedPass = sanitizePassword(pw, CONSTANTS.PASSWORD_MIN, CONSTANTS.USER_NAME_MAX);
  if (!sanitizedUser || !sanitizedPass) {
    throw Error("Invalid Request Data");
  }

  form.append("u", btoa(sanitizedUser));
  form.append("p", btoa(sanitizedPass));

  const url = `${getCloudServerPath()}/wp-json/data/login`;

  const headers = new Headers();
  headers.append("Accept", "application/json");

  const settings = {
    method: "POST",
    headers,
    body: form,
    redirect: 'follow',
    mode : 'cors',
    credentials: 'include'
  }

  console.log("trying to login as user: " + sanitizedUser);
  const responseData = await doRequest(url, settings);
  console.log("response after login ", responseData);
  processUserLoginResponse(responseData);
}

export const checkUser = async (tryLogin : boolean) => {

  const url = `${getCloudServerPath()}/wp-json/data/login`;

  const headers = new Headers();
  headers.append("Accept", "application/json");

  const settings = {
    headers,
    method: "POST",
    mode : 'cors',
    redirect : 'follow',
    credentials: 'include'
  }

  const responseData = await doRequest(url, settings);
  console.log("response after login ", responseData);
  processUserLoginResponse(responseData);
  if (responseData.success !== true || responseData.status !== 200) {
    if (tryLogin) {
      triggerLoginModal();
    }
    throw Error("Check logged in user failed! Trying login!");
  }
}

export const processUserLoginResponse = (responseData: any ) => {
  if (responseData.success === true && responseData.status === 200) {
    const cloudUser = getCloudUser();
    if (responseData.nonce) {
      cloudUser.nonce = responseData.nonce;
    }
    cloudUser.userName = responseData.user;
    if (responseData.name) {
      cloudUser.name = responseData.name;
    }
    cloudUser.userCaps = responseData.caps;
    cloudUser.loggedIn = true;
    setCloudUser(cloudUser);
    addLogin();
  } else {
    console.log("login failed");
    clearCloudSession();
    throw Error("login-failed-toast-title");
  }
}

export const logoutUser = async () => {

  const url = `${getCloudServerPath()}/wp-json/data/logout`;
  const settings = {
    method: "GET",
    mode : 'cors',
    redirect : 'follow',
    credentials: 'include'
  }

  await doRequest(url, settings);
  clearCloudSession();
  cleanLocalProjects();
  removeAchievementsFromLS();

}

export const registerUser = async (email : string, pw : string, pwc : string) => {

  const form = new FormData();
  const sanitizedMail = sanitizeInput(email, CONSTANTS.EMAIL_MIN, CONSTANTS.EMAIL_MAX);
  const sanitizedPass = sanitizePassword(pw, CONSTANTS.PASSWORD_MIN, CONSTANTS.USER_NAME_MAX);
  const sanitizedPassConfirmation = sanitizePassword(pwc, CONSTANTS.PASSWORD_MIN, CONSTANTS.USER_NAME_MAX);
  if (!sanitizedMail || !sanitizedPass) {
    throw Error("login-signup-failed-toast-title");
  }

  form.append("email", btoa(sanitizedMail));
  form.append("password", btoa(sanitizedPass));
  form.append("password_confirmation", btoa(sanitizedPassConfirmation));

  const url = `${getCloudServerPath()}/wp-json/data/register`;

  const settings = {
    url: `${getCloudServerPath()}/wp-json/data/register`,
    method: "POST",
    body: form,
    mode : 'cors',
    redirect : 'follow'
  }

  const responseData = await doRequest(url, settings);
  if (responseData.success !== true) {
    throw Error("login-signup-failed-text");
  }
}
